import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable, OnInit } from '@angular/core';
import { CompanyLocationGridDataService } from 'common/services/data-services/admin/internship-company/internship-company-location-grid-data.service';
import { CompanyLocationModel } from 'common/models/page-models/internship-company/company-location/company-location-data.model';
import { CompanyLocationGridMetaModel } from 'common/models/page-models/internship-company/company-location/company-location-grid-meta.model';
import { CompanyLocationListingModel } from 'common/models/page-models/internship-company/company-location/company-location-grid.model';



@Injectable({
    providedIn: 'root'
})
export class CompanyLocationGridWidgetService extends GridWidgetService<CompanyLocationModel, CompanyLocationListingModel> {
    constructor(protected override ds: CompanyLocationGridDataService, protected systemService: SystemService) {
        super(ds);
    }


    getMetaModel(): MetaModel {
        const meta = new CompanyLocationGridMetaModel().getMetaModel();
        return meta;
    }
   


}